/** @jsxImportSource @emotion/react */
import { CircularProgress, DialogContent, Snackbar, Typography } from '@mui/material';
import React, { useState,useContext } from 'react';
import { useEffect } from 'react';
import config from '../../config';
import Popup, { PopupTitle } from '../CustomPopup';
import axios from '../../Helper/Axios/interceptor';
import MySnackbarContentWrapper from '../Snackbars';
import PDFViewer from '../PDFViewer';
import { Il8nContext } from '../../Helper/i18n';


function UploadedDocumentViewer(props) {
    const { proofID, setUploadedDocProofID } = props
    const [openUploadedDocumentPopup, setOpenUploadedDocumentPopup] = useState(false)
    const [snackBarOpen, setSnackBarOpen] = useState(false)
    const [responseStatus, setResponseStatus] = useState({})
    const [document, setDocument] = useState()
    const localeText = useContext(Il8nContext)

    
    useEffect(()=>{
        if(proofID){
            setOpenUploadedDocumentPopup(true)
            getUploadedDocument()
        }
    }, [proofID])
    
    useEffect(()=>{
        if(!openUploadedDocumentPopup){
            setDocument()
            setUploadedDocProofID()
        } 
    }, [openUploadedDocumentPopup])
    
    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const getUploadedDocument= ()=>{
        let payload = {
            id: proofID,
            productType:"diy"
        }
        axios.post(process.env.REACT_APP_API_URL+config.getDocument, payload)
            .then(resp => {
                if (resp.data.success) {
                    setDocument(resp.data.success[0])
                }
                else {
                    throw new Error(resp.data.error)
                }
            })
            .catch(error => {
                setResponseStatus({ "message": error.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const toggleUploadDocumentViewerPopup = ()=>{
        setOpenUploadedDocumentPopup(!openUploadedDocumentPopup)
    }

    return (
        <>
            <Popup
                open={openUploadedDocumentPopup}
                maxWidth={"lg"}
                fullScreen={document?.fileType?.toLowerCase() === "pdf"}
            >
                <PopupTitle onClose={toggleUploadDocumentViewerPopup}>
                    <Typography display={"inline"} variant="body1" css={{ fontWeight:"bold", verticalAlign: "top", lineHeight:1 }}>
                        { localeText?.uploadUploadedDocument /* document.documentSubType + " " + document.documentTypeCode */}
                    </Typography>
                </PopupTitle>
                <DialogContent css={{ margin: "0px 30px" }}>
                    {document ? 
                        ((document.fileType.toLowerCase() === "jpg" || document.fileType.toLowerCase() === "jpg" || document.fileType.toLowerCase() === "jpg") ? 
                                    <img css={{width:"100%"}} src={`data:image/${document.fileType};base64,${document.base64Format}`} alt="uploadedImage"/>
                                    : (document.fileType.toLowerCase() === "mp4" || document.fileType.toLowerCase() === "mov") ? 
                                        <video controls>
                                            <source src={document.base64Format && document.fileType && "data:video/"+document.fileType+";base64,"+document.base64Format || ""} type={"video/"+document.fileType} />
                                        </video>
                                        : (document.fileType.toLowerCase() === "pdf") && 
                                            <PDFViewer pdfFile={"data:application/pdf;base64," + document.base64Format} />)
                            
                        : 
                        <CircularProgress />
                    }
                </DialogContent>
            </Popup>
            
            {responseStatus && responseStatus.message && <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={snackBarOpen}
                autoHideDuration={5000}
                onClose={handleSnackBarClose}
            >
                <MySnackbarContentWrapper
                    onClose={handleSnackBarClose}
                    variant={responseStatus.type}
                    message={responseStatus.message}
                />
            </Snackbar>}
        </>
    );
}

export default UploadedDocumentViewer;